import type { ClientReputation } from "@utah-vr/shared";

export async function fetchReputation(): Promise<{ reputations: ClientReputation[] }> {
	const res = await fetch("/api/reputation");
	if (!res.ok) throw new Error(`reputation fetch failed: ${res.status}`);
	return res.json();
}
